import React, { useState, useEffect } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Page404 from '../page404';
import Mainhome from './home';
import DetailTheme from './Detail';
import AddTheme from './Add';
import EditTheme from './Edit';
import { getThemes,getSingleTheme } from '../redux/actions/actTheme';
import { isAuth } from '../auth/actions';
import { Redirect } from 'react-router';
import {getAllTemplates} from './actions'

export default function Home() {
  const { path } = useRouteMatch();

  return (
    <React.Fragment>
     {isAuth() ? (
      <Switch>
        <Route exact path={path}>
          <Mainhome/>
        </Route>
        <Route path={`${path}/add`}>
          <AddTheme/>
        </Route>
        <Route path={`${path}/edit/:id`}>
          <EditTheme/>
        </Route>
        <Route path={`${path}/detail/:id`}>
          <DetailTheme/>
        </Route>
        <Route path={`${path}/*`}>
          <Page404 />
        </Route>
      </Switch>
       ) : (
          <Redirect to='/auth' />
      )}
    </React.Fragment>
  );
}
